import type { GetStringValueParams } from '../types';

const getStringValue = ({ value }: GetStringValueParams): string =>
    typeof value === 'string' ? value : '';

export default getStringValue;
